import React, { useRef, useState, useEffect, useLayoutEffect } from "react";
import MiniSideBar from "../../components/mini-sidebar";
import {
  Box,
  Flex,
  Image,
  Menu,
  MenuButton,
  Text,
  MenuList,
  MenuItem,
  Td,
  Tr,
  Collapse,
  Textarea,
  Card,
  CardBody,
  Divider,
} from "@chakra-ui/react";
import SecondaryNav from "../../components/seconday-nav";
import PrimaryButton from "../../components/primary-button";
import DynamicModal from "../../components/dynamic-modal";
import ModalRight from "../../components/modal-right";
import useLoader from "../../components/loader/loaderstates";
import Loader from "../../components/loader/loader";
import SimpleTable from "../../components/simple-table";
import {
  DropdownInput,
  PrimaryInput,
  PrimaryInputDropdown,
  SearchBar,
  Toaster,
} from "../../components";

import {
  BrowserRouter as Router,
  generatePath,
  Routes,
  Route,
  useNavigate,
  useParams,
} from "react-router-dom";

import MobileNavbar from "../../components/mobile-navbar";
import MobileSecondaryNav from "../../components/mobile-secondary-navbar";
import DatePicker from "../../components/date-picker";
import { formatDate_YYYY_MM_DD, getLoginID, handleAlphaDotAndSpace, handleNumericDotAndSpace, useScreenType } from "../../auth";
import {
  AddReferHospitals,
  DeleteReferHospitals,
  GetReferHospitals,
  UpdateReferHospitals,
} from "../../middleware/services/referhospitals";
import { format } from "date-fns";
import { addSupplier, deleteSupplier, FetchSupplierFullDetail, getSupplier, updateSupplier } from "../../middleware/services/profile";
import moment from "moment";
import AssignMedicineIndex from "./assignmedicines";

const SupplierIndex = () => {
  const { isLoading, showLoader, dismissLoader } = useLoader();
  const { showSuccessToast, showErrorToast } = Toaster();
  const [editHospitalData, setEditHospitalData] = useState([]);
  const [searchValue, setSearchValue] = useState([]);
  const [hospitalId, setHospitalId] = useState(null);
  const [hospitalName, setHospitalName] = useState(null);
  const [hospitalEmail, setHospitalEmail] = useState(null);
  const [hospitalMobile, setHospitalMobile] = useState(null);
  const [hospitalBranch, setHospitalBranch] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItemCount, setTotalItemCount] = useState(0);
  const [supplierData, setSupplierData] = useState([]);

  const [supplierName, setSupplierName] = useState("");
  const [editId, setEditid] = useState("");
      const [personName, setPersonName] = useState("");
      const [email, setEmail] = useState("");
      const [phoneNumber, setPhoneNumber] = useState("");
      const [countryid, setcountryid] = useState(null);
      const [countrycode, setcountrycode] = useState(null);
      const [supplierAddress, setSupplierAddress] = useState("");
      const [supplierCity, setSupplierCity] = useState("");
      const [supplierState, setSupplierState] = useState("");
      const [supplierCountry, setSupplierCountry] = useState("");
      const [postalCode, setPostalCode] = useState("");
      const [gstin, setGST] = useState("");


  var itemPerPageCommonValue = 10;
  let [pagesize, setPagesize] = useState(itemPerPageCommonValue);
  let [pageno, setPageno] = useState(1);
  let [countTo, setCountTo] = useState(itemPerPageCommonValue);
  let [countFrom, setCountFrom] = useState(1);
  let [totalExceedsPageCount, setTotalExceedsPageCount] = useState(false);

  const addSupplierModal = useRef();
  const editSupplierModal = useRef();
  const deleteSupplierModal = useRef();
  const showSupplierDetails = useRef();

  const screenType = useScreenType()
  const navigate = useNavigate()

  const fetchSupplierList = async () => {
    const input = {
        doctorid: getLoginID(),
        searchtext: "",
        fromdate: "",
        todate: "",
        pagenumber: pageno,
        pagesize: pagesize,
    };
    showLoader();
    try {
      const result = await getSupplier(input);
      setSupplierData(result.output.data);
      let count = result?.output.count;
      let pageno = result?.output.pageno;
      let pagesize = result?.output.pagesize;
      setTotalItemCount(count);
      let totalPagesCalc = count / pagesize;
      let totalPagesCount = Math.ceil(totalPagesCalc);

      setTotalPages(totalPagesCount);
    } catch (error) {
      console.log("Error fetching Refer center data", error);
    }
    dismissLoader();
    return;
  };

  const getFilteredResults = async () => {
    const input = {
        doctorid: getLoginID(),
        searchtext: searchValue,
        startdate: fromDate,
        enddate: toDate,
        pagenumber: pageno,
        pagesize: pagesize,
    };
    showLoader();
    try {
      const result = await getSupplier(input);
      setSupplierData(result.output.data);
      let count = result?.output.count;
      let pageno = result?.output.pageno;
      let pagesize = result?.output.pagesize;
      setTotalItemCount(count);
      let totalPagesCalc = count / pagesize;
      let totalPagesCount = Math.ceil(totalPagesCalc);

      setTotalPages(totalPagesCount);
    } catch (error) {
      console.log("Error fetching Refer center data", error);
    }
    dismissLoader();
    return;
  };

  useEffect(() => {
    fetchSupplierList();
  }, [currentPage]);

  const handleMobileChange = (e) => {
    var countryCode = localStorage.getItem("countrycode");
    var countryId = localStorage.getItem("countryid");

    setcountryid(countryCode);
    setcountrycode(countryId);

    setPhoneNumber(e.target.value.replace(/[^0-9]/g, "").slice(0, 11));
  };

  const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [ toDateMinMax , setToDateMinMax] = useState("")
      const [ fromDateMinMax , setFromDateMinMax] = useState("")

  const handleFromDate = (selectedDate) => {
      const formattedDate = format(selectedDate, "dd-MM-yyyy");
     // console.log('formattedDAte: ', formattedDate)
      setFromDate(formattedDate);
  
      setFromDateMinMax(selectedDate);
    };
    const handleToDate = (selectedDate) => {
      const formattedDate = format(selectedDate, "dd-MM-yyyy");
      setToDate(formattedDate);
  
      setToDateMinMax(selectedDate);
    };

  const formatDate = (dateString) => {
      if (!dateString) return "-";
      return moment(dateString).format("Do MMM, YYYY");
    };

  //  ---------------------------- Add Functionality Start --------------------------------
  
    function clearState() {
      setSupplierName('')
      setPersonName('')
      setEmail('')
      setPhoneNumber('')
      setcountrycode("+91")
      setcountryid('95')
      // setcountrycode("+1")
      // setcountryid('229')
      setSupplierAddress('')
      setSupplierCity('')
      setSupplierState('')
      setSupplierCountry('')
      setPostalCode('')
      setGST('')
    }
  
    const openAddSupplierModal = () => {
      clearState();
      addSupplierModal.current.openRight();
    };
  
    async function addSupplierFunction() {
      if (!supplierName) {
        showErrorToast("Please Enter Supplier Name!");
        return false;
      } else if (!personName) {
        showErrorToast("Please select Person Name!");
        return false;
      } else if (!email) {
        showErrorToast("Please select Email!");
        return false;
      } else if (!phoneNumber) {
        showErrorToast("Please select Phone Number!");
        return false;
      } else if (!supplierAddress) {
        showErrorToast("Please select Address!");
        return false;
      } else if (!supplierCity) {
        showErrorToast("Please select City!");
        return false;
      } else if (!supplierState) {
        showErrorToast("Please select State!");
        return false;
      } else if (!supplierCountry) {
        showErrorToast("Please select Country!");
        return false;
      } else if (!postalCode) {
        showErrorToast("Please select Pin Code!");
        return false;
      } else if (!gstin) {
        showErrorToast("Please select GSTIN!");
        return false;
      }
      showLoader();
      let addSupplierInput = {
        "suppliername": supplierName,
    "contactperson": personName,
    "supplieremail": email,
    "supplierphone": phoneNumber,
	"countrycode":countrycode,
	"countryid":countryid,
    "address": supplierAddress,
    "city": supplierCity,
    "state": supplierState,
    "country": supplierCountry,
    "postalcode": postalCode,
    "gstin": gstin,
      };
      try {
        let result = await addSupplier(addSupplierInput);
        // console.log(result, " result of add branch.");
        if (result.output.result == "success") {
          showSuccessToast("Supplier added Successfully!");
        //   setRefreshPageData(!refreshPageData);
        fetchSupplierList();
          addSupplierModal.current.closeRight();
        }else {
          showErrorToast("Something went Wrong!");
        }
      } catch (error) {
        console.log(error, " error in creating pharmacy");
      }
      dismissLoader();
    }
  
  //  ---------------------------- Add Functionality end --------------------------------

  //  ---------------------------- Edit Functionality start --------------------------------
    async function editSupplierFunction() {
        if (!supplierName) {
            showErrorToast("Please Enter Supplier Name!");
            return false;
          } else if (!personName) {
            showErrorToast("Please select Person Name!");
            return false;
          } else if (!email) {
            showErrorToast("Please select Email!");
            return false;
          } else if (!phoneNumber) {
            showErrorToast("Please select Phone Number!");
            return false;
          } else if (!supplierAddress) {
            showErrorToast("Please select Address!");
            return false;
          } else if (!supplierCity) {
            showErrorToast("Please select City!");
            return false;
          } else if (!supplierState) {
            showErrorToast("Please select State!");
            return false;
          } else if (!supplierCountry) {
            showErrorToast("Please select Country!");
            return false;
          } else if (!postalCode) {
            showErrorToast("Please select Pin Code!");
            return false;
          } else if (!gstin) {
            showErrorToast("Please select GSTIN!");
            return false;
          }
      showLoader();
      let editSupplierInput = {
        "id": editId,
    "suppliername": supplierName,
    "contactperson": personName,
    "supplieremail": email,
    "supplierphone": phoneNumber,
    "countrycode":countrycode,
	"countryid":countryid,
    "address": supplierAddress,
    "city": supplierCity,
    "state": supplierState,
    "country": supplierCountry,
    "postalcode": postalCode,
    "gstin": gstin,
	// "countrycode":"+91",
	// "countryid":"197",
      };
      try {
        let result = await updateSupplier(editSupplierInput);
  
        if (result.output.result == "success") {
          showSuccessToast("Supplier updated Successfully!");
        //   setRefreshPageData(!refreshPageData);
          // addPharmacyModal.current.closeRight();
          fetchSupplierList();
          editSupplierModal.current.closeRight();
        } else {
          showErrorToast("Something went Wrong!");
        }
      } catch (error) {
        console.log(error, " error in editing branch");
      }
  
      // console.log(input , " add branch input")
  
      dismissLoader();
    }
    function openEditSupplier(item) {
      console.log('item of edit: ', item)
      // setbranchid(item.branchid);
      setEditid(item.id)
      setSupplierName(item.suppliername);
      setPersonName(item.contactperson);
      setcountrycode(item.countrycode)
      setcountryid(item.countryid)
      setEmail(item.supplieremail);
      setPhoneNumber(item.supplierphone);
      setSupplierAddress(item.address);
      setSupplierCity(item.city);
      setSupplierState(item.STATE);
      setSupplierCountry(item.country);
      setPostalCode(item.postalcode);
      setGST(item.gstin);

  
      editSupplierModal.current.openRight();
    }
  
  //  ---------------------------- edit Functionality end --------------------------------

  const [deleteid, setDeleteid] = useState('')
  const openDeleteModal = (id, name) => {
    setDeleteid(id);
    setSupplierName(name);
    deleteSupplierModal.current.openModal();
  };

//   const saveHospitalData = async () => {
//     const inputToSave = {
//       input: {
//         doctorid: getLoginID(),
//         hospitalname: hospitalName,
//         email: hospitalEmail,
//         mobile: hospitalMobile,
//         address: hospitalBranch,
//       },
//     };
//     if (!hospitalName) {
//       showErrorToast("Please enter Center name");
//       return false;
//     } else {
//       showLoader();
//       const res = await AddReferHospitals(inputToSave.input);
//       // setHospitalData((prevData) => [...(prevData || []), inputToSave]); // Ensure prevData is iterable
//       setRefresh(!refresh);
//       showSuccessToast("Center added successfully.");
//       fetchHospitalData();
//       dismissLoader();
//     }
//     addSupplierModal.current.closeRight();
//   };
//   const updateHospitalData = async () => {
//     const inputToSave = {
//       input: {
//         id: hospitalId,
//         doctorid: getLoginID(),
//         hospitalname: hospitalName,
//         email: hospitalEmail,
//         mobile: hospitalMobile,
//         address: hospitalBranch,
//       },
//     };

//     if (!hospitalName) {
//       showErrorToast("Please enter Center name");
//       return false;
//     } else {
//       const res = await UpdateReferHospitals(inputToSave.input);
//       setEditHospitalData("");
//       setHospitalName("");
//       setHospitalEmail("");
//       setHospitalMobile("");
//       setHospitalBranch("");
//       showSuccessToast("Center updated successfully.");
//       fetchHospitalData();
//       editSupplierModal.current.closeRight();
//       return res;
//     }
//   };

  const deleteSupplierData = async () => {
    const inputToDelete = {
      input: {
        doctorid: getLoginID(),
        id: deleteid,
      },
    };
    showLoader();
    try {
      const result = await deleteSupplier(inputToDelete.input);
      if(result && result.output.result === "success") {
        showSuccessToast("Supplier deleted successfully.");
        fetchSupplierList();
    deleteSupplierModal.current.closeModal();
      }
    } catch (error) {
      console.log("Error in deleting the Refer center data", error);
    }
    fetchSupplierList();
    dismissLoader();
    return;
  };

  const handleChangeName = (event) => {
    let inputValue = event.target.value;
    inputValue = inputValue.replace(/[^A-Za-z0-9\s@._-]/g, "").slice(0, 50);
    setSearchValue(inputValue);
  };

  async function handleFilter() {
    // const trimmedName = searchValue?.trim();
    // const inputToFetch = {
    //   input: {
    //     doctorid: getLoginID(),
    //     searchtext: trimmedName,
    //     fromdate: "",
    //     todate: "",
    //     pageno: pageno,
    //     pagesize: pagesize,
    //   },
    // };
    // showLoader();
    // try {
    //   const result = await getSupplier(inputToFetch.input);
    //   if (result && result.output.data) {
    //     setSupplierData(result.output.data);
    //   } else {
    //     setSupplierData([]);
    //   }
    // } catch (error) {
    //   console.log("Error fetching Refer center data", error);
    // }
    // dismissLoader();
    getFilteredResults();
  }

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleFilter();
    }
  };

  async function resetFeilds() {
    setSearchValue("");
    setFromDate("")
    setToDate("")
    setToDateMinMax("")
    setFromDateMinMax("")    
    setPagesize(itemPerPageCommonValue);
    setCountFrom(1);
    setCountTo(itemPerPageCommonValue);
    setCurrentPage(1);
    fetchSupplierList();
  }

  const handleNextClick = () => {
    let page = pageno + 1;

    setPageno(page);
    setCurrentPage(currentPage + 1);

    if (countTo + pagesize < totalItemCount) {
      setCountTo(countTo + pagesize);
    } else {
      setCountTo(totalItemCount);
    }

    setCountFrom(countFrom + pagesize);
  };
  const handlePrevClick = () => {
    let page = pageno - 1;

    setPageno(page);
    setCurrentPage(currentPage - 1);
    if (countTo == totalItemCount) {
      let updatedCountUnroundedValue = totalItemCount - pagesize;
      setCountTo(
        Math.ceil(updatedCountUnroundedValue / itemPerPageCommonValue) *
          itemPerPageCommonValue
      );
    } else {
      setCountTo(countTo - pagesize);
    }

    setCountFrom(countFrom - pagesize);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const TableHeader = [
    { key: "supplierName", label: "Supplier Name" },
    { key: "personName", label: "Name" },
    { key: "supplierEmail", label: "Email" },
    { key: "mobile", label: "Mobile no." },
    { key: "supplierAddress", label: "Address" },
    { key: "gstin", label: "GSTIN" },
    { key: "date", label: "Date" },
    { key: "actions", label: "Actions" },
  ];
  const ModalTableHeader = [
    { key: "medicineName", label: "Medicine Name" },
    { key: "chemicalcomposition", label: "Chemical Composition" },
    { key: "medicinetype", label: "Medicine Type" },
    { key: "manufacturer", label: "Manufacturer" },
    // { key: "supplierAddress", label: "Address" },
    // { key: "gstin", label: "GSTIN" },
    // { key: "date", label: "Date" },
    // { key: "actions", label: "Actions" },
  ];
  const tableRef = useRef();


  // const supplierLogsData = [
  //   {
  //     "id": 10,
  //     "supplierid": 5,
  //     "doctorid": 1,
  //     "medicineid": 101,
  //     "medicinename": "Paracetamol",
  //     "medicinetype": "Tablet",
  //     "dosage": "500mg",
  //     "dosageunit": "mg",
  //     "medicationstartdate": "2024-01-10",
  //     "medicationenddate": null,
  //     "frequency": "Twice Daily",
  //     "morning": 1,
  //     "afternoon": 0,
  //     "evening": 1,
  //     "beforefood": 0,
  //     "afterfood": 1,
  //     "prescribedby": "Dr. Sharma",
  //     "prescribedhospitalname": "ABC Hospital",
  //     "iscurrentmedicine": 1,
  //     "medicationstatus_cd": null,
  //     "medicineunit": "Tablet",
  //     "night": 0,
  //     "chemicalcomposition": "Paracetamol",
  //     "benefit": "Fever reducer",
  //     "sideeffects": "Nausea",
  //     "inventoryid": 555,
  //     "modifieddate": "2024-01-12",
  //     "frequencytime": null,
  //     "frequencyvalue": null,
  //     "drugclass": "Antipyretic",
  //     "therapeutic": "Yes",
  //     "manufacturer": "MediPharma",
  //     "instructions": "Take after food"
  //   },
  //   {
  //     "id": 10,
  //     "supplierid": 5,
  //     "doctorid": 1,
  //     "medicineid": 101,
  //     "medicinename": "Paracetamol",
  //     "medicinetype": "Tablet",
  //     "dosage": "500mg",
  //     "dosageunit": "mg",
  //     "medicationstartdate": "2024-01-10",
  //     "medicationenddate": null,
  //     "frequency": "Twice Daily",
  //     "morning": 1,
  //     "afternoon": 0,
  //     "evening": 1,
  //     "beforefood": 0,
  //     "afterfood": 1,
  //     "prescribedby": "Dr. Sharma",
  //     "prescribedhospitalname": "ABC Hospital",
  //     "iscurrentmedicine": 1,
  //     "medicationstatus_cd": null,
  //     "medicineunit": "Tablet",
  //     "night": 0,
  //     "chemicalcomposition": "Paracetamol",
  //     "benefit": "Fever reducer",
  //     "sideeffects": "Nausea",
  //     "inventoryid": 555,
  //     "modifieddate": "2024-01-12",
  //     "frequencytime": null,
  //     "frequencyvalue": null,
  //     "drugclass": "Antipyretic",
  //     "therapeutic": "Yes",
  //     "manufacturer": "MediPharma",
  //     "instructions": "Take after food"
  //   },
  //   {
  //     "id": 10,
  //     "supplierid": 5,
  //     "doctorid": 1,
  //     "medicineid": 101,
  //     "medicinename": "Paracetamol",
  //     "medicinetype": "Tablet",
  //     "dosage": "500mg",
  //     "dosageunit": "mg",
  //     "medicationstartdate": "2024-01-10",
  //     "medicationenddate": null,
  //     "frequency": "Twice Daily",
  //     "morning": 1,
  //     "afternoon": 0,
  //     "evening": 1,
  //     "beforefood": 0,
  //     "afterfood": 1,
  //     "prescribedby": "Dr. Sharma",
  //     "prescribedhospitalname": "ABC Hospital",
  //     "iscurrentmedicine": 1,
  //     "medicationstatus_cd": null,
  //     "medicineunit": "Tablet",
  //     "night": 0,
  //     "chemicalcomposition": "Paracetamol",
  //     "benefit": "Fever reducer",
  //     "sideeffects": "Nausea",
  //     "inventoryid": 555,
  //     "modifieddate": "2024-01-12",
  //     "frequencytime": null,
  //     "frequencyvalue": null,
  //     "drugclass": "Antipyretic",
  //     "therapeutic": "Yes",
  //     "manufacturer": "MediPharma",
  //     "instructions": "Take after food"
  //   },
  //   {
  //     "id": 10,
  //     "supplierid": 5,
  //     "doctorid": 1,
  //     "medicineid": 101,
  //     "medicinename": "Paracetamol",
  //     "medicinetype": "Tablet",
  //     "dosage": "500mg",
  //     "dosageunit": "mg",
  //     "medicationstartdate": "2024-01-10",
  //     "medicationenddate": null,
  //     "frequency": "Twice Daily",
  //     "morning": 1,
  //     "afternoon": 0,
  //     "evening": 1,
  //     "beforefood": 0,
  //     "afterfood": 1,
  //     "prescribedby": "Dr. Sharma",
  //     "prescribedhospitalname": "ABC Hospital",
  //     "iscurrentmedicine": 1,
  //     "medicationstatus_cd": null,
  //     "medicineunit": "Tablet",
  //     "night": 0,
  //     "chemicalcomposition": "Paracetamol",
  //     "benefit": "Fever reducer",
  //     "sideeffects": "Nausea",
  //     "inventoryid": 555,
  //     "modifieddate": "2024-01-12",
  //     "frequencytime": null,
  //     "frequencyvalue": null,
  //     "drugclass": "Antipyretic",
  //     "therapeutic": "Yes",
  //     "manufacturer": "MediPharma",
  //     "instructions": "Take after food"
  //   },
  // ]

  const [supplierLogsData, setSupplierLogsData] = useState("");

  const openSupplierDetailsModal = (id) => {
    showSupplierDetails.current.openRight()
    FetchSupplierfullDetails(id)
  }
  const FetchSupplierfullDetails = async (Id) => {
    showLoader();
    try {
        const result = await FetchSupplierFullDetail({
          "doctorid": getLoginID(),
            "supplierid": Id
        });

        console.log('supplier full data', result)
        // var data = result.data;
        if (result && result.output.data) {
          setSupplierLogsData(result.output.data);
        }
        dismissLoader();
        // console.log('data', data)
    } catch (error) {
        console.error("Error in home:", error);
    } finally {
        dismissLoader();
    }
};

const gobackfunction = ()=>{
  window.history.back();
 }

  return (
    <>
    {screenType === "web" ? (
      <Box w="100%">
        <Flex>
          <Box w="6rem">
            <MiniSideBar />
          </Box>
          {isLoading && <Loader />}
          <Box w="100%">
            <SecondaryNav withBack="Supplier Management" goBack={gobackfunction} />
            <Box
              gap="10px"
              my="1rem"
              px="1rem"
              w="100%"
              display="flex"
              flexDirection="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Box
                gap="10px"
                // pl="1rem"
                w="100%"
                display="flex"
                flexDirection="row"
                justifyContent="start"
                alignItems="center"
              >
                <PrimaryInput
                  variant="fullRound"
                  title="Search by name, email, mobile"
                  inputPlace="Search by name, email, mobile"
                  id={"searchName"}
                  inputStyleCss={{ w: "350px" }}
                  onKeyDown={handleKeyDown}
                  onChange={(e) => handleChangeName(e)}
                  inputValue={searchValue}
                />
                 <Box w='300px'>
                       <DatePicker
                          //  defaultDate={procedureDate}
                           onDateChange={(selectedDateValue) =>
                             handleFromDate(selectedDateValue)
                           }
                           placeholderProp="From Date"
                           datePickerInputStyle={{ borderRadius: "10px 10px 10px 10px" }}
                           value={fromDate} 
                           clearValue={true}
         
                           CUSTOM_DISABLE={true}
                           disableFutureDates={true}
                           maxDate={toDateMinMax}
                         />
                       </Box>
                         <Box w='300px'>
                       <DatePicker
                           onDateChange={(selectedDateValue) =>
                             handleToDate(selectedDateValue)
                           }
                           placeholderProp="To Date"
                           datePickerInputStyle={{ borderRadius: "10px 10px 10px 10px " }}
                           value={toDate} 
                           clearValue={true}
                           
                           
                           CUSTOM_DISABLE={true}
                           maxDate={new Date().toISOString()} 
                           minDate={fromDateMinMax}
                         />
                         </Box>
                <PrimaryButton
                  buttonText="Filter"
                  id="filterButton"
                  onClick={() => handleFilter()}
                  btnStyle={{ m: "0", w: "125px" }}
                />
                <PrimaryButton
                  buttonText="Reset"
                  id="resetButton"
                  variant="grayBtnFull"
                  btnStyle={{ color: "#AA2F27", m: "0", w: "125px" }}
                  onClick={() => resetFeilds()}
                />
              </Box>
              {/* <PrimaryButton ml='5rem' w='200px' buttonText="Assign" id="filterButton" onClick={()=> navigate('/assignsupplier')}  /> */}
              <PrimaryButton
                buttonText="Add"
                // onClick={() => openHospitalModal("", "add")}
                onClick={() => openAddSupplierModal()}
                btnStyle={{ m: "0" }}
                w="125px"
                //   isDisabled={ actionAccess && (!actionAccess.create) ? true : false}
              />

              {/* {noData && <p>No data available</p>} */}
            </Box>
            {supplierData && supplierData.length > 0 ? (
              <>
                <Box width="100%">
                  <Box
                    h="calc(100vh - 90px)"
                    overflow="hidden auto"
                    border="1px solid #E6E7E9"
                  >
                    <SimpleTable
                      headers={TableHeader}
                      className="tableContainer"
                      isDataPresent={true}
                      currentPage={currentPage}
                      onPageChange={handlePageChange}
                      tableHeader={{ pos: "sticky", top: "0", bg: "white" }}
                      footerStyle={{
                        pos: "fixed",
                        bottom: "0",
                        boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px",
                        zIndex: "99",
                        width: "100%",
                      }}
                      tableStyle={{
                        maxH: "calc(100vh - 200px)",
                        overflowY: "auto",
                        tableLayout: "fixed",
                        width: "100%",
                        h: "100%",
                      }}
                      tableBody={
                        <>
                          {supplierData &&
                            supplierData.map((item, index) => (
                              <Tr w="100%" key={index}>
                                <Td maxW="200px">
                                  <Box
                                    as="p"
                                    className="textOverflow"
                                    textAlign={"left"}
                                  >
                                    {item.suppliername ? item.suppliername : "-"}
                                  </Box>
                                </Td>

                                <Td maxW="200px">
                                  <Box
                                    title={""}
                                    whiteSpace="pre-line"
                                    overflow="hidden"
                                    fontSize={"s"}
                                    textAlign={"left"}
                                  >
                                    {item.contactperson ? item.contactperson : "-"}
                                  </Box>
                                </Td>

                                <Td maxW="150px">
                                  <Box width="15%" textAlign={"left"}>
                                    {item.supplieremail ? item.supplieremail : "-"}
                                  </Box>
                                </Td>

                                <Td maxW="200px">
                                  <Box
                                    as="p"
                                    className="textOverflow"
                                    textAlign={"left"}
                                  >
                                    {/* {item.supplierphone ? item.supplierphone : '-'} */}
                                    {item?.supplierphone ? `${item?.countrycode || '+91'} ${item?.supplierphone}` : '-'}
                                    {/* {item?.supplierphone ? `${item?.countrycode || '+1'} ${item?.supplierphone}` : '-'} */}
                                  </Box>
                                </Td>

                                <Td maxW="200px">
                                  <Box
                                    as="p"
                                    className="textOverflow"
                                    textAlign={"left"}
                                  >
                                    {item.address ? item.address : '-'}
                                  </Box>
                                </Td>

                                <Td maxW="200px">
                                  <Box
                                    as="p"
                                    className="textOverflow"
                                    textAlign={"left"}
                                  >
                                    {item.gstin ? item.gstin : "-"}
                                  </Box>
                                </Td>

                                <Td maxW="200px">
                                  <Box
                                    as="p"
                                    className="textOverflow"
                                    textAlign={"left"}
                                  >
                                    {item.createddate ? formatDate(item.createddate) : "-"}
                                  </Box>
                                </Td>

                                <Td maxW="130px" pos="relative">
                                  <Menu>
                                    <MenuButton as="button" zIndex={1}>
                                      <Image
                                        w="1.5rem"
                                        src="/assets/svgs/more-options.svg"
                                        // transform='rotate(90deg)'
                                      />
                                    </MenuButton>
                                    <MenuList
                                      zIndex={9999}
                                      pos="relative"
                                      right="-33px"
                                      minW="125px"
                                    >
                                      <MenuItem
                                        // onClick={() => navigate('/assignsupplier')}
                                        onClick={() => navigate(`/assignsupplier?suppId=${item.id}`)}
                                        // isDisabled={ actionAccess && (!actionAccess.update) ? true : false}
                                      >
                                        Assign
                                      </MenuItem>
                                      <MenuItem
                                        // onClick={() =>
                                        //   openHospitalModal(item.id, "edit")
                                        // }
                                        onClick={() => openSupplierDetailsModal(item.id)}

                                        // isDisabled={ actionAccess && (!actionAccess.update) ? true : false}
                                      >
                                        View Details
                                      </MenuItem>
                                      <MenuItem
                                        // onClick={() =>
                                        //   openHospitalModal(item.id, "edit")
                                        // }
                                        onClick={() => openEditSupplier(item)}

                                        // isDisabled={ actionAccess && (!actionAccess.update) ? true : false}
                                      >
                                        Edit
                                      </MenuItem>
                                      <MenuItem
                                        onClick={() => {
                                          openDeleteModal(
                                            item.id,
                                            item.suppliername
                                          );
                                        }}
                                      >
                                        Delete
                                      </MenuItem>
                                    </MenuList>
                                  </Menu>
                                </Td>
                              </Tr>
                            ))}
                        </>
                      }
                      footerSection={
                        <>
                          <Tr w="100%">
                            <Td colSpan={5} w="calc(100vw - 6.5rem)">
                              <Box
                                w="100%"
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                              >
                                <Box
                                  visibility={
                                    totalItemCount < countTo &&
                                    !totalExceedsPageCount
                                      ? "hidden"
                                      : "visible"
                                  }
                                >
                                  <Text>
                                    Showing <b>{countFrom}</b> to{" "}
                                    <b>{countTo}</b> of {totalItemCount} results
                                  </Text>
                                </Box>

                                <Box
                                  gap="2.5rem"
                                  display="flex"
                                  justifyContent="space-between"
                                  alignItems="center"
                                >
                                  <Box
                                    as="button"
                                    onClick={handlePrevClick}
                                    disabled={currentPage === 1}
                                    visibility={
                                      currentPage === 1 ? "hidden" : "visible"
                                    }
                                    p="0.5rem 0.75rem"
                                    border="0.0625rem solid #E6E7E9"
                                    borderRadius="0.75rem"
                                    fontSize="1rem"
                                    fontWeight="500"
                                  >
                                    Previous
                                  </Box>
                                  <Box>
                                    <Text
                                      textAlign="center"
                                      fontSize=".875rem"
                                      fontWeight="600"
                                    >
                                      Page {currentPage} of {totalPages}
                                    </Text>
                                  </Box>
                                  {totalItemCount >= countTo &&
                                    !totalExceedsPageCount && (
                                      <Box
                                        as="button"
                                        p="0.5rem 0.75rem"
                                        mr="2.5rem"
                                        border="0.0625rem solid #E6E7E9"
                                        borderRadius="0.75rem"
                                        onClick={handleNextClick}
                                        disabled={currentPage === totalPages}
                                        visibility={
                                          currentPage === totalPages
                                            ? "hidden"
                                            : "visible"
                                        }
                                        fontSize="1rem"
                                        fontWeight="500"
                                      >
                                        Next
                                      </Box>
                                    )}
                                </Box>
                              </Box>
                            </Td>
                          </Tr>
                        </>
                      }
                    />
                  </Box>
                </Box>
              </>
            ) : (
              <Box width="100%">
                <SimpleTable
                  headers={TableHeader}
                />
              </Box>
            )}
          </Box>
        </Flex>
      </Box>
    ) : (
      <>
      <MobileNavbar />
         <MobileSecondaryNav
           header="Referring Centers"
           handlebackarrow={() => navigate(`/profile`)}
         />
       <Box
         w="100%"
         display="flex"
         justifyContent="space-between"
         alignItems="center"
         p="1rem"
         gap='0.75rem'
       >
         <SearchBar
          passInputPlace="Search by name, email, mobile"
          onKeyDown={handleKeyDown}
          onChange={(e) => handleChangeName(e)}
          handleClick={() => handleFilter()}
          searchValue={searchValue}
          placeholderMaxWidth='150px'
         />
        <PrimaryButton
          buttonText="Reset"
          id="resetButton"
          variant="grayBtn"
          btnStyle={{ color: "#AA2F27", m: "0", w: "75px" }}
          onClick={() => resetFeilds()}
        />
         <PrimaryButton
           buttonText="Add"
        //    onClick={() => openHospitalModal("", "add")}
        onClick={() => openAddSupplierModal()}
           variant="mdBtn"
           btnStyle={{w:'75px'}}
          //  isDisabled={actionAccess && !actionAccess.create ? true : false}
         />
       </Box>
       <Divider />
       <Flex w='100%' gap='1rem' p='1rem' flexDir='column' maxH="calc(100vh - 275px)" overflow='hidden auto'>
       {supplierData && supplierData.length > 0 ? (
         supplierData.map((item, index) => (
         <Card
           borderRadius="12px"
           key={index}
           w="100%"
           border="1px solid #E6E7E9"
           boxShadow="0px 8px 20px 0px #E6E7E966"
         >
           <CardBody p={{base: "0.875rem",lg: "0.875rem", xl: "1.25rem"}}>
             <Box
               display="flex"
               alignItems="center"
               justifyContent="space-between"
               mb="0.75rem"
             >                  
               <Box cursor="pointer" display="flex" alignItems="center">
                 <Box display="flex" flexDirection="column" justifyContent="center">
                   <Text fontSize="15px" fontWeight="600" className="textOverflow" title={item.productname ? item.productname : "-"} maxW={{base: "180px", xl:"110px"}}>
                   {item.hospitalname ? item.hospitalname : "-"}
                   </Text>
                 </Box>
               </Box>

                 <Box display="flex" gap="10px">
                   <Menu isLazy>
                     <MenuButton as="button" zIndex={1}>
                       <Image
                         w="1rem"
                         src="/assets/svgs/more-options.svg"
                         transform='rotate(90deg)'
                       />
                     </MenuButton>
                     <MenuList
                       zIndex={9}
                       pos="relative"
                       right="0"
                       minW="125px"
                     >
                       <MenuItem
                        //   onClick={() =>
                        //     openHospitalModal(item.id, "edit")
                        //   }
                onClick={() => openEditSupplier()}

                        //  isDisabled={
                        //    actionAccess && !actionAccess.update
                        //      ? true
                        //      : false
                        //  }
                       >
                         Edit
                       </MenuItem>

                       <MenuItem
                         onClick={() => {
                          openDeleteModal(
                            item.id,
                            item.hospitalname
                          );
                        }}
                        //  isDisabled={
                        //    actionAccess && !actionAccess.update
                        //      ? true
                        //      : false
                        //  }
                       >
                         Delete
                       </MenuItem>
                     </MenuList>
                   </Menu>    
                 </Box>
                 
             </Box>
             <Flex w='100%' mb="0.75rem" justifyContent='space-between'>
               <Box display='flex' flexDir='column'>
               
                   <Text fontSize="10px" color="gray.500">
                     Product type
                   </Text>
                   <Text fontSize="12px" fontWeight="600">
                     {item.email ? item.email : "-"}
                   </Text>
                   
                 </Box>
                 <Box display='flex' flexDir='column' alignItems="center">
               
               <Text fontSize="10px" color="gray.500">
                 Batch no.
               </Text>
               <Box
                   as="button"
                 >
                   <Text fontSize="12px" fontWeight="600">
                   {item.mobile ? item.mobile : "-"}
               </Text>
                 </Box>
               
             
             </Box>
             </Flex>
           
           </CardBody>

         </Card>
       ))) : (
         <Text>No data available</Text>
       )}
       </Flex>
     </>
    )}
      <ModalRight
        ref={addSupplierModal}
        header="Add Supplier"
        modalWidth={{ base: "100%", lg: "calc(100vw - 70%)" }}
        body={
          <>
            <Box w="100%" py="1rem">
              <Box w="100%" display="flex" flexDir="column">
                <PrimaryInput
                  inputPlace="Supplier Name*"
                  //   variant="leftSide"
                  //   inputValue={"firstname"}
                  onChange={(e) => setSupplierName(e.target.value)}
                />
                <PrimaryInput
                  inputPlace="GSTIN*"
                    variant="bothSide"
                  //   inputValue={"firstname"}
                  onChange={(e) => setGST(e.target.value)}
                />
                <PrimaryInput
                  inputPlace="Name*"
                    variant="bothSide"
                  //   inputValue={"firstname"}
                  onChange={(e) => setPersonName(e.target.value)}
                />
                <PrimaryInput
                  inputPlace="Enter Email"
                  variant="bothSide"
                  //   inputValue={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                
                <PrimaryInputDropdown
                  // onChange={(e) =>
                  //   setPhoneNumber(
                  //     e.target.value.replace(/[^0-9]/g, "").slice(0, 11)
                  //   )
                  // }
                  onChange={(e) => handleMobileChange(e)}
                  inputValue={phoneNumber}
                  id="mobile"
                  variant="bothSide"
                  placeholderProp="Phone number"
                />
                {/* <Textarea
                  placeholder="Enter Address"
                  borderRadius="0 0 10px 10px"
                  value={supplierAddress}
                  onChange={(e) => setSupplierAddress(e.target.value)}
                /> */}


                <Box w="100%" display="flex">
                                  <PrimaryInput
                                    inputPlace="Address"
                                    variant="bothSide"
                                    // defaultValue={addressData.address1}
                                    // inputValue={branchAddress1}
                                    // onChange={(e) => setBranchAddress1(e.target.value)}
                                    onChange={(e) => setSupplierAddress(e.target.value)}
                                    maxLength={50}
                                  />
                                </Box>
                
                                {/* <Box w="100%" display="flex">
                                  <PrimaryInput
                                    variant="bothSide"
                                    inputPlace="Address 2"
                                    // defaultValue={addressData.address2}
                                    // inputValue={branchAddress2}
                                    // onChange={(e) => setBranchAddress2(e.target.value)}
                                    maxLength={50}
                                  />
                                </Box> */}
                
                                <Box w="100%" display="flex">
                                  <PrimaryInput
                                    variant="bothSide"
                                    inputPlace="City*"
                                    // defaultValue={addressData.city}
                                    // inputValue={branchCity}
                                    // onChange={(e) =>
                                    //   setBranchCity(handleAlphaDotAndSpace(e.target.value))
                                    // }
                                    onChange={(e) => setSupplierCity(handleAlphaDotAndSpace(e.target.value))}
                                    maxLength={50}
                                  />
                                </Box>
                
                                <Box w="100%" display="flex">
                                  <PrimaryInput
                                    variant="bothSide"
                                    inputPlace="State*"
                                    // defaultValue={addressData.state}
                                    // inputValue={branchState}
                                    // onChange={(e) =>
                                    //   setBranchState(handleAlphaDotAndSpace(e.target.value))
                                    // }
                                    onChange={(e) => setSupplierState(handleAlphaDotAndSpace(e.target.value))}
                                    maxLength={50}
                                  />
                                  <PrimaryInput
                                    variant="bothSide"
                                    inputPlace="Pin Code*"
                                    // defaultValue={addressData.pincode}
                                    // inputValue={branchPinCode}
                                    // onChange={(e) =>
                                    //   setBranchPinCode(handleNumericDotAndSpace(e.target.value))
                                    // }
                                    onChange={(e) => setPostalCode(handleNumericDotAndSpace(e.target.value))}
                                    maxLength={6}
                                  />
                                </Box>
                
                                <Box w="100%" display="flex">
                                  <PrimaryInput
                                    variant="downSide"
                                    inputPlace="Country*"
                                    // defaultValue={addressData.country}
                                    // inputValue={branchCountry}
                                    // onChange={(e) =>
                                    //   setBranchCountry(handleAlphaDotAndSpace(e.target.value))
                                    // }
                                    onChange={(e) => setSupplierCountry(handleAlphaDotAndSpace(e.target.value))}
                                    maxLength={50}
                                  />
                                </Box>
              </Box>
            </Box>
          </>
        }
        footerActions={
          <>
            <Flex gap="1.5rem" w="100%">
              <PrimaryButton
                buttonText="Cancel"
                variant="grayBtnFull"
                btnStyle={{ color: "#AA2F27" }}
                onClick={() => addSupplierModal.current.closeRight()}
              />
              <PrimaryButton buttonText="Save" onClick={addSupplierFunction} />
            </Flex>
          </>
        }
      />

      <ModalRight
        ref={editSupplierModal}
        header="Edit Supplier"
        modalWidth={{ base: "100%", lg: "calc(100vw - 70%)" }}
        body={
          <>
            {supplierData && supplierData.length > 0 && (
              <Box w="100%" py="1rem">
                {/* <Box w="100%" display="flex" flexDir="column">
                  <PrimaryInput
                    inputPlace="Enter Name*"
                    //   variant="leftSide"
                    defaultValue={hospitalName}
                    onChange={(e) => setHospitalName(e.target.value)}
                  />
                  <PrimaryInput
                    inputPlace="Enter Email"
                    variant="bothSide"
                    defaultValue={hospitalEmail}
                    onChange={(e) => setHospitalEmail(e.target.value)}
                  />
                  <PrimaryInputDropdown
                    onChange={(e) =>
                      setHospitalMobile(
                        e.target.value.replace(/[^0-9]/g, "").slice(0, 11)
                      )
                    }
                    defaultValue={hospitalMobile}
                    id="mobile"
                    variant="bothSide"
                    placeholderProp="Phone number"
                  />
                  <Textarea
                    placeholder="Enter Address"
                    borderRadius="0 0 10px 10px"
                    defaultValue={hospitalBranch}
                    onChange={(e) => setHospitalBranch(e.target.value)}
                  />
                </Box> */}

<Box w="100%" display="flex" flexDir="column">
                <PrimaryInput
                  inputPlace="Supplier Name*"
                  //   variant="leftSide"
                  //   inputValue={"firstname"}
                  defaultValue={supplierName}
                  onChange={(e) => setSupplierName(e.target.value)}
                />
                <PrimaryInput
                  inputPlace="GSTIN*"
                    variant="bothSide"
                  defaultValue={gstin}
                  //   inputValue={"firstname"}
                  onChange={(e) => setGST(e.target.value)}
                />
                <PrimaryInput
                  inputPlace="Name*"
                    variant="bothSide"
                  //   inputValue={"firstname"}
                  defaultValue={personName}
                  onChange={(e) => setPersonName(e.target.value)}
                />
                <PrimaryInput
                  inputPlace="Enter Email"
                  variant="bothSide"
                  //   inputValue={email}
                  defaultValue={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                
                <PrimaryInputDropdown
                  // onChange={(e) =>
                  //   setPhoneNumber(
                  //     e.target.value.replace(/[^0-9]/g, "").slice(0, 11)
                  //   )
                  // }
                  onChange={(e) => handleMobileChange(e)}
                  inputValue={phoneNumber}
                  defaultValue={phoneNumber}
                  id="mobile"
                  variant="bothSide"
                  placeholderProp="Phone number"
                />
                {/* <Textarea
                  placeholder="Enter Address"
                  borderRadius="0 0 10px 10px"
                  value={supplierAddress}
                  onChange={(e) => setSupplierAddress(e.target.value)}
                /> */}


                <Box w="100%" display="flex">
                                  <PrimaryInput
                                    inputPlace="Address"
                                    variant="bothSide"
                                    defaultValue={supplierAddress}
                                    // inputValue={branchAddress1}
                                    // onChange={(e) => setBranchAddress1(e.target.value)}
                                    onChange={(e) => setSupplierAddress(e.target.value)}
                                    maxLength={50}
                                  />
                                </Box>
                
                                {/* <Box w="100%" display="flex">
                                  <PrimaryInput
                                    variant="bothSide"
                                    inputPlace="Address 2"
                                    // defaultValue={addressData.address2}
                                    // inputValue={branchAddress2}
                                    // onChange={(e) => setBranchAddress2(e.target.value)}
                                    maxLength={50}
                                  />
                                </Box> */}
                
                                <Box w="100%" display="flex">
                                  <PrimaryInput
                                    variant="bothSide"
                                    inputPlace="City*"
                                    defaultValue={supplierCity}
                                    // inputValue={branchCity}
                                    // onChange={(e) =>
                                    //   setBranchCity(handleAlphaDotAndSpace(e.target.value))
                                    // }
                                    onChange={(e) => setSupplierCity(handleAlphaDotAndSpace(e.target.value))}
                                    maxLength={50}
                                  />
                                </Box>
                
                                <Box w="100%" display="flex">
                                  <PrimaryInput
                                    variant="bothSide"
                                    inputPlace="State*"
                                    defaultValue={supplierState}
                                    // inputValue={branchState}
                                    // onChange={(e) =>
                                    //   setBranchState(handleAlphaDotAndSpace(e.target.value))
                                    // }
                                    onChange={(e) => setSupplierState(handleAlphaDotAndSpace(e.target.value))}
                                    maxLength={50}
                                  />
                                  <PrimaryInput
                                    variant="bothSide"
                                    inputPlace="Pin Code*"
                                    defaultValue={postalCode}
                                    // inputValue={branchPinCode}
                                    // onChange={(e) =>
                                    //   setBranchPinCode(handleNumericDotAndSpace(e.target.value))
                                    // }
                                    onChange={(e) => setPostalCode(handleNumericDotAndSpace(e.target.value))}
                                    maxLength={6}
                                  />
                                </Box>
                
                                <Box w="100%" display="flex">
                                  <PrimaryInput
                                    variant="downSide"
                                    inputPlace="Country*"
                                    defaultValue={supplierCountry}
                                    // inputValue={branchCountry}
                                    // onChange={(e) =>
                                    //   setBranchCountry(handleAlphaDotAndSpace(e.target.value))
                                    // }
                                    onChange={(e) => setSupplierCountry(handleAlphaDotAndSpace(e.target.value))}
                                    maxLength={50}
                                  />
                                </Box>
              </Box>
              </Box>
            )}
          </>
        }
        footerActions={
          <>
            <Flex gap="1.5rem" w="100%">
              <PrimaryButton
                buttonText="Cancel"
                variant="grayBtnFull"
                btnStyle={{ color: "#AA2F27" }}
                onClick={() => editSupplierModal.current.closeRight()}
              />
              <PrimaryButton buttonText="Save" onClick={editSupplierFunction} />
            </Flex>
          </>
        }
      />

      {/* Delete general dietician notes */}
      <DynamicModal
        ref={deleteSupplierModal}
        modalHeader={`Delete Supplier`}
        modalBody={
          <>
            <Text fontSize="14px" fontWeight="600">
              Are you sure you want to Delete {supplierName}?
            </Text>
          </>
        }
        modalFooterBtn={
          <>
            <PrimaryButton
              variant="deleteBtn"
              buttonText="Delete"
              btnStyle={{
                w: "100%",
                h: "2.5rem",
              }}
              onClick={() => {
                deleteSupplierData();
                // deleteSupplierModal.current.closeModal();
              }}
            />
          </>
        }
      />

      {/* Supplier Details logs */}
      <ModalRight
            ref={showSupplierDetails}
            modalWidth="800px"
            // header="Supplier Medicine Details"
            header="Supplier Assigned Medicine"
            body={
              <>
              {supplierLogsData && supplierLogsData.length>0 ? (
                <Box flex="1" p="24px 32px">
  {/* <Box> */}
         
          <Box
          border="1px solid #E6E7E9"
          ref={tableRef}
        >
          <SimpleTable
            headers={ModalTableHeader}
            className='tableContainer'
            isDataPresent={true}
            ref={tableRef}
            // currentPage={currentPage} onPageChange={handlePageChange}
            footerStyle={{pos: "sticky", bottom: "-1px",boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px"}}
            tableStyle={{maxH:"calc(100vh - 175px)",overflowY: "auto", tableLayout: "fixed", width: "100%"}}
            tableBody={
              <>
              {
                supplierLogsData.map((step, index) => (
                <Tr w="100%" index={index}>
                  <Td maxW="200px">
                    <Box
                      w="100%"
                      display="flex"
                      gap="0.5rem"
                      alignItems="center"
                    >
                      {/* <Box boxSize="2.75rem">
                        <Image boxSize="40px" h="40px" objectFit="cover" src={step.      profilepictureurl? step.imagepath + step.profilepictureurl:"/assets/imgs/no-image.png"} borderRadius="full" />
                      </Box> */}
                      <Box w="80%" maxW="8rem" isTruncated>
                        <Text
                          className="textOverflow"
                          fontSize=".875rem"
                          fontWeight="600"
                        >
                      {step.medicinename ? step.medicinename : ('-')}
                        </Text>
                      </Box>
                    </Box>
                  </Td>

                  <Td maxW="200px">
                    <Text fontSize=".875rem" fontWeight="500" isTruncated title={step.chemicalcomposition ? step.chemicalcomposition : "-"}>
                      {/* viqar@gmail.com */}
                    {step.chemicalcomposition ? step.chemicalcomposition : ('-')}
                    </Text>
                  </Td>

                  {/* <Td maxW="200px">
                      <Text
                        fontSize=".75rem"
                        fontWeight="600"
                        isTruncated
                        >
                        {step.usertype ? step.usertype : ('-')}
                      </Text>
                  </Td> */}

                  <Td maxW="130px">
                    <Text fontSize=".875rem" fontWeight="500" isTruncated>
                      {step.medicinetype ? step.medicinetype : ('-')}
                    </Text>
                  </Td>
                  <Td maxW="130px">
                    <Text fontSize=".875rem" fontWeight="500" isTruncated>
                      {step.manufacturer ? step.manufacturer : ('-')}
                    </Text>
                  </Td>

                  {/* <Td maxW="130px">
                    <Menu>
                      <MenuButton as='button'>
                        <Image w="1.5rem" src="/assets/svgs/more-options.svg" />
                      </MenuButton>
                      <MenuList zIndex={9999} pos="absolute" right="-33px" minW="125px">
                        <MenuItem onClick={()=> {
                        openNotificationDetails(step.id)
                      }}>
                          View
                        </MenuItem>
                      </MenuList>
                    </Menu>
                  </Td> */}
                </Tr>
              ))}
              </>
            }
          />
        </Box>
  {/* </Box> */}
</Box>
// </Box>
              ):('No data available')}
              </>
            }
          />

      
    </>
  );
};

export default SupplierIndex;
